"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_ORDER_RECEIPT = void 0;
const client_1 = require("@apollo/client");
exports.GET_ORDER_RECEIPT = client_1.gql `
  query getOrderReceipt($idTransaction: String!) {
    receiptBase64(idTransaction: $idTransaction)
  }
`;
